import { useState } from 'react';
import { Sparkles } from 'lucide-react';
import { toast } from '@/components/ui/sonner';
import { generatePlayoff } from '@/data/generate-playoff';
import type { Match, Tournament } from '@/data/types';

interface Props {
  tournament: Tournament;
  matches: Match[];
}

export function GeneratePlayoffButton({ tournament, matches }: Props) {
  const [busy, setBusy] = useState(false);
  if (tournament.format !== 'GROUPS_PLAYOFF') return null;

  const hasPlayoff = matches.some((m) => m.stage === 'PLAYOFF');
  if (hasPlayoff) return null;

  const groupMatches = matches.filter((m) => m.stage === 'GROUP');
  const incomplete = groupMatches.filter((m) => m.status !== 'COMPLETED').length;
  const canGenerate = groupMatches.length > 0 && incomplete === 0;

  async function handleClick() {
    setBusy(true);
    try {
      const { sameGroupR1Conflicts } = await generatePlayoff(tournament);
      toast.success('Плей-офф сгенерирован');
      if (sameGroupR1Conflicts > 0) {
        toast.warning('Проверьте сетку плей-офф', {
          description: `В сетке плей-офф ${sameGroupR1Conflicts} пар(ы) из одной группы встречаются в первом раунде — развести не удалось из-за конфигурации групп.`,
        });
      }
    } catch (err) {
      toast.error('Не получилось', { description: String((err as Error).message) });
    } finally {
      setBusy(false);
    }
  }

  return (
    <div
      className="card-d row"
      style={{ padding: 14, justifyContent: 'space-between', gap: 12, flexWrap: 'wrap' }}
    >
      <div>
        <div style={{ fontWeight: 500 }}>Групповой этап</div>
        {incomplete > 0 && (
          <div className="t-small t-mute">Осталось матчей: {incomplete}</div>
        )}
      </div>
      <button
        className="btn btn-primary btn-sm"
        onClick={handleClick}
        disabled={!canGenerate || busy}
      >
        {busy ? (
          <>
            <span className="spinner" /> Генерируем...
          </>
        ) : (
          <>
            <Sparkles size={14} /> Сгенерировать плей-офф
          </>
        )}
      </button>
    </div>
  );
}
